import { render, staticRenderFns } from "./data-edit.vue?vue&type=template&id=3dafdd94&scoped=true&"
import script from "./data-edit.vue?vue&type=script&lang=js&"
export * from "./data-edit.vue?vue&type=script&lang=js&"
import style0 from "./data-edit.vue?vue&type=style&index=0&id=3dafdd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafdd94",
  null
  
)

export default component.exports